<template>
  <router-link :to="{name: 'Producten'}">
    <GordijnenManLogo />
  </router-link>
</template>

<script>
  import GordijnenManLogo from '../components/GordijnenManLogo'

  export default {
    components: {
      GordijnenManLogo
    }
  }
</script>
